import moment from "moment";
import DOMPurify from "dompurify";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import menuBg from "../../assets/images/bg/menu/request.svg";
import FooterBottom from "../../components/footerBottom";
// compoennst
import Header from "../../components/header";
import MainMenu from "../../components/mainMenu";
import { getTermsDetailsAction } from "../App/actions";
import logo from "../../assets/images/logo.png";
import { Col, Container, Row } from "react-bootstrap";

const TermsOfService = (props) => {
  const [openMenu, setOpenMenu] = useState(false);
  const [keyword, setKeyword] = useState("");
  const handleOpenMenu = () => {
    setOpenMenu(!openMenu);
  };
  const handleCloseMenuMenu = () => {
    setOpenMenu(false);
  };
  useEffect(() => {
    props.getTermsDetailsAction();
  }, []);
  useEffect(() => {
    if (props?.terms?.keyword?.length > 0) {
      const data = props?.terms?.keyword;
      const pp = data.toString();
      setKeyword(pp);
    }
  }, [props?.terms?.keyword]);
  return (
    <>
      <Helmet>
        <title>Read our Terms of Service - The Clarity Cooperative</title>
        <meta name="title" content={"Read our Terms of Service - The Clarity Cooperative"} />
        <meta name="description" content={props.terms?.excerpt} />
        <meta name="keywords" content={keyword} />
        <meta property="og:title" content={"Read our Terms of Service - The Clarity Cooperative"} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={props?.terms?.url} />
        <meta property="og:image" content={logo} />
        <meta property="og:site_name" content="clarity cooperative" />
        <meta property="og:description" content={props?.terms?.excerpt} />
        <meta name="twitter:card" content={props.terms?.excerpt} />
        <meta property="twitter:domain" content="ccdev.brethren.io" />
        <meta property="twitter:url" content={props?.terms?.url} />
        <meta name="twitter:title" content={"Read our Terms of Service - The Clarity Cooperative"} />
        <meta name="twitter:description" content={props?.terms?.excerpt} />
        <meta name="twitter:image" content={logo} />
      </Helmet>
      <MainMenu closeMenu={handleCloseMenuMenu} title="NAVIGATE" bgImage={menuBg} className={openMenu ? "active" : ""} />
      <Header openMenu={handleOpenMenu} className="headerStyleBlack" blackLogo />

      <Container className="pt-3 pt-lg-4 pt-xl-5">
        <Row className="justify-content-center">
          <Col sm={10} md={9}>
            <span className="text-sm text-uppercase fw-bold">Last Updated {moment(props.terms?.updated_at).format("MMMM Do, YYYY")}</span>
            <h1 className="my-4">{props.terms?.name}</h1>
            <div
              className="termsContent"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(props.terms?.contents),
              }}
            />
          </Col>
        </Row>
      </Container>
      <FooterBottom />
    </>
  );
};
const mapStateToProps = (state) => ({
  terms: state.cms.terms,
});
export default connect(mapStateToProps, {
  getTermsDetailsAction,
})(TermsOfService);
